/**
 * Types provide helper functions related to Interfaces and Types
 */

/**
 * Extracts the permitted property names for the given object type or interface.
 * e.g. const incProp = propertyNamesOf<IncidentsColumnDefinition>();
 * incProp("Id")
 * @param ob Type of object whose property names should be extracted.
 * @returns Yields the permitted property names for TObject.
 */
export function propertyNamesOf<TObject>(ob: TObject | undefined = undefined) {
    return function getPropName<T extends keyof TObject>(propName: T) {
        return propName;
    };
}

export function isKeyOf<T extends object>(key: string | number | symbol, obj: T): key is keyof T {
    return key in obj;
}

export const nonNullable = <T>(value: T): value is NonNullable<T> => value !== null && value !== undefined;

export function isDefined<
    Type,
    Key extends keyof Type,
    DefinedType extends { [Property in keyof Type]: Property extends Key ? NonNullable<Type[Property]> : Type[Property] }
>(key: Key) {
    return (obj: Type): obj is DefinedType => {
        const property = obj[key];
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return property !== undefined && property !== null;
    };
}

export function getKeyArray<T extends object>(obj: T): Array<keyof T> {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj) as Array<keyof T>;
}

export const getUndefined = <T>(): T | undefined => undefined;
